import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class CapsLockStateService {
    constructor() {
        this.capsLockOnSubject = new BehaviorSubject(false);
        this.capsLockOn$ = this.capsLockOnSubject.asObservable();
        window.addEventListener('keydown', (event) => this.updateState(event));
        window.addEventListener('keyup', (event) => this.updateState(event));
    }
    updateState(event) {
        this.capsLockOnSubject.next(event.getModifierState('CapsLock'));
    }
}
CapsLockStateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CapsLockStateService_Factory() { return new CapsLockStateService(); }, token: CapsLockStateService, providedIn: "root" });
